/* eslint-disable import/prefer-default-export */
import { sanitizeImage } from './images'

export async function sanitizeFile(
  file: File | undefined
): Promise<File | undefined> {
  if (!file) return undefined
  if (file.type.includes('image')) {
    return await sanitizeImage(file)
  }
  return file
}
